// src/components/Login/LoginPage.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import apiService from '../../API/ApiService';

const LoginPage = ({ login }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async () => {
    setIsLoading(true);
    setErrorMessage('');

    try {
      // 🔹 Récupération des utilisateurs
      const response = await apiService.get('/getAllUsers');

      if (!response?.data || !Array.isArray(response.data)) {
        throw new Error('Réponse invalide du serveur');
      }

      // 🔹 Recherche utilisateur (logique code 1 + sécurité code 2)
      const userFound = response.data.find(u =>
        u.email?.toLowerCase() === username.trim().toLowerCase() &&
        u.password === password
      );

      if (!userFound) {
        setErrorMessage('Identifiants incorrects');
        return;
      }

      // 🔹 Stockage utilisateur (clé pour filtrer les données)
      localStorage.setItem('username', userFound.email);
      localStorage.setItem('userId', userFound.id);
      localStorage.setItem('userRole',
        userFound.email === 'MPSI' ? 'MPSI_ADMIN' : 'USER'
      );

      // 🔹 Marquer comme connecté
      login();

      // 🔹 Redirection intelligente
      if (userFound.email === 'MPSI') {
        navigate('/app/jig'); // Admin MPSI
      } else {
        navigate('/app/tester-interface', {
          state: { username: userFound.email }
        });
      }

    } catch (error) {
      console.error('Erreur login :', error);
      setErrorMessage(
        error.response?.data?.message || 'Erreur de connexion au serveur'
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-form">

        <div className="logo">
          <img src="/logo_ds5.png" alt="DS5 Logo" />
        </div>

        <h2>DS5 Tester</h2>

        <input
          type="text"
          placeholder="Email ou Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
        />

        <button onClick={handleLogin} disabled={isLoading}>
          {isLoading ? 'Connexion...' : 'Se connecter'}
        </button>

        {errorMessage && (
          <p className="error-message">{errorMessage}</p>
        )}

      </div>

      <footer className="login-footer">
        <p>© {new Date().getFullYear()} DS5. Tous droits réservés.</p>
      </footer>
    </div>
  );
};

export default LoginPage;
